 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account~equipment~home~patients~pricing~saas":"account~equipment~home~patients~pricing~saas","pricing":"pricing","saas":"saas","home~patient~patient-comparison~patient-result":"home~patient~patient-comparison~patient-result","home":"home","auth--complete-profile~auth--create-profile~auth--reset-password~auth--sign-in~auth--sign-up":"auth--complete-profile~auth--create-profile~auth--reset-password~auth--sign-in~auth--sign-up","auth--reset-password":"auth--reset-password","auth--sign-in":"auth--sign-in","auth--sign-up":"auth--sign-up","account":"account","equipment":"equipment","patients":"patients","auth--complete-profile":"auth--complete-profile","auth--create-profile":"auth--create-profile","settings":"settings","patient":"patient","patient-comparison":"patient-comparison","patient-result":"patient-result","not-found":"not-found"}[chunkId]||chunkId) + "." + {"account~equipment~home~patients~pricing~saas":"6602511c","pricing":"fc6e0e68","saas":"c12ea275","chunk-5f9e11d1":"99d5a71a","chunk-6d04e3ad":"f2f33f44","chunk-7e4e9783":"8d3fb6b0","home~patient~patient-comparison~patient-result":"096e0831","home":"1fb014a6","chunk-eca98bde":"947adb1b","auth--complete-profile~auth--create-profile~auth--reset-password~auth--sign-in~auth--sign-up":"f9a61c67","auth--reset-password":"ea85c8ab","auth--sign-in":"a89435d2","auth--sign-up":"e15daff9","chunk-1a1af89c":"abdbea5f","account":"9fe4dba0","equipment":"599ce954","patients":"f2c97637","auth--complete-profile":"d479399a","auth--create-profile":"88e0fb72","chunk-7b706733":"7d23659f","chunk-64a7490e":"299f8322","settings":"97e48e27","patient":"21db6bdf","patient-comparison":"d281c646","patient-result":"6cdaa554","not-found":"0ae0366a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account~equipment~home~patients~pricing~saas":1,"pricing":1,"saas":1,"chunk-5f9e11d1":1,"chunk-6d04e3ad":1,"chunk-7e4e9783":1,"home~patient~patient-comparison~patient-result":1,"home":1,"chunk-eca98bde":1,"auth--complete-profile~auth--create-profile~auth--reset-password~auth--sign-in~auth--sign-up":1,"auth--reset-password":1,"auth--sign-in":1,"auth--sign-up":1,"chunk-1a1af89c":1,"account":1,"equipment":1,"patients":1,"auth--complete-profile":1,"auth--create-profile":1,"chunk-7b706733":1,"chunk-64a7490e":1,"settings":1,"patient":1,"patient-comparison":1,"patient-result":1,"not-found":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account~equipment~home~patients~pricing~saas":"account~equipment~home~patients~pricing~saas","pricing":"pricing","saas":"saas","home~patient~patient-comparison~patient-result":"home~patient~patient-comparison~patient-result","home":"home","auth--complete-profile~auth--create-profile~auth--reset-password~auth--sign-in~auth--sign-up":"auth--complete-profile~auth--create-profile~auth--reset-password~auth--sign-in~auth--sign-up","auth--reset-password":"auth--reset-password","auth--sign-in":"auth--sign-in","auth--sign-up":"auth--sign-up","account":"account","equipment":"equipment","patients":"patients","auth--complete-profile":"auth--complete-profile","auth--create-profile":"auth--create-profile","settings":"settings","patient":"patient","patient-comparison":"patient-comparison","patient-result":"patient-result","not-found":"not-found"}[chunkId]||chunkId) + "." + {"account~equipment~home~patients~pricing~saas":"c592f4a7","pricing":"d50b3d4a","saas":"ae24e6f4","chunk-5f9e11d1":"9ceb08f1","chunk-6d04e3ad":"b6855847","chunk-7e4e9783":"f0222215","home~patient~patient-comparison~patient-result":"aa01e12c","home":"a64a1088","chunk-eca98bde":"2bebb24e","auth--complete-profile~auth--create-profile~auth--reset-password~auth--sign-in~auth--sign-up":"0fd7496d","auth--reset-password":"3f4c7f9f","auth--sign-in":"a509ed62","auth--sign-up":"c7309c2a","chunk-1a1af89c":"19c56cb8","account":"65f732fb","equipment":"406b0fc1","patients":"7283056d","auth--complete-profile":"a955663f","auth--create-profile":"1b4ec05a","chunk-7b706733":"5e559fd0","chunk-64a7490e":"451670d8","settings":"ed4d4331","patient":"73fe8d01","patient-comparison":"ac8a51e6","patient-result":"b361eea8","not-found":"5a1e8313"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
